import React, {useMemo} from 'react'
import {useTranslation} from 'i18n'
import {TransactionStatus} from 'types'
import TemplateTransactionHistoryContentItemCommon from './TemplateTransactionHistoryContentItemCommon'
import {TemplateWaitingTransactionHistoryContentItemProps} from './TemplateTransactionWaitingHistoryContentItemProps'

export default function TemplateTransactionWaitingHistoryContentItem({
  data: {amount, transaction_date, transaction_partner: creator, status},
  onClickItem,
}: TemplateWaitingTransactionHistoryContentItemProps) {
  const {translate} = useTranslation()

  const transaction_partner = useMemo(
    () =>
      creator.length > 1
        ? `${creator.length} ${translate('global:creators')}`
        : creator[0],
    [creator, translate],
  )

  return (
    <TemplateTransactionHistoryContentItemCommon
      data={{
        amount,
        transaction_date,
        transaction_partner,
        transaction_type: 'Purchase',
        status: status as TransactionStatus,
      }}
      onClickItem={onClickItem}
    />
  )
}
